// extracted by mini-css-extract-plugin
module.exports = {"quizResult":"QuizResult_quizResult__8EKAv","buttonWrapper":"QuizResult_buttonWrapper___V5pW","desktopWrapper":"QuizResult_desktopWrapper__0RHg4"};